(function () {
  function isMobileMenu() {
    return window.matchMedia('(max-width: 1199px)').matches;
  }

  function buildViewAllItem(href, text) {
    var li = document.createElement('li');
    li.className = 'yy-view-all-item';
    var a = document.createElement('a');
    a.href = href;
    a.className = 'yy-view-all-link';
    a.textContent = 'Ver tudo em ' + text;
    li.appendChild(a);
    return li;
  }

  function setup() {
    document.querySelectorAll('.megamenu-content button[data-bs-toggle="collapse"]').forEach(function (btn) {
      var link = btn.previousElementSibling;
      if (!link || link.tagName !== 'A' || btn.dataset.yyBound) return;
      btn.dataset.yyBound = '1';

      link.addEventListener('click', function (e) {
        if (!isMobileMenu()) return;
        e.preventDefault();

        var targetSelector = btn.getAttribute('data-bs-target');
        var targetList = targetSelector ? document.querySelector(targetSelector) : null;

        if (targetList) {
          var insertionParent = targetList.querySelector(':scope > .container-fluid > .ul') || targetList;
          if (!insertionParent.querySelector('.yy-view-all-item')) {
            insertionParent.insertBefore(
              buildViewAllItem(link.href, link.textContent.trim()),
              insertionParent.firstChild
            );
          }
        }

        btn.click();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
